import type { TPricing } from "~/components/cards/Pricing.vue";

export const internetPhonePrices: Array<TPricing> = [
    {
      title: "سرشماره‌های 8",
      img: "/img/new/pricing/8-digit.webp",
      chip: "راه‌اندازی رایگان",
      amounts: [
        {
          title: "به ازای هر ماه/ پرداخت سالانه",
          value: "252",
          unit: "هزار تومان"
        }
      ]
    },
    {
      title: "سرشماره‌ی 9",
      img: "/img/new/pricing/9-digit.webp",
      chip: "راه‌اندازی رایگان",
      amounts: [
        {
          title: "به ازای هر ماه/ پرداخت سالانه",
          value: "162",
          unit: "هزار تومان"
        }
      ]
    }
];